/**
 * 制限時間モーダル
 *************************************************/
import moment from 'moment';
import React, { FC, useCallback, useEffect, useState } from 'react';
import { Modal, Transition } from 'semantic-ui-react';

export interface TimeUpModalProps {
  isOpen: boolean;
  currentPage: 'example' | 'question';
  action: () => void | Promise<void>;
  categoryNo?: number;
}
const TimeUpModal: FC<TimeUpModalProps> = ({ isOpen, action, currentPage, categoryNo }) => {
  let modalMessage: string;
  if (currentPage === 'example') {
    modalMessage = '問題を開始します';
  } else if (categoryNo === 5) {
    modalMessage = '適性検査試験を終了します。';
  } else {
    modalMessage = '次の問題へ進みます。';
  }

  const [timeLimit, setTimeLimit] = useState<number>(5000);
  const [intervalID, setIntervalID] = useState<number>();

  // カウントダウン処理
  const countdown = useCallback(() => {
    setTimeLimit((count: number) => count - 1000);
  }, []);

  // 1秒ごとにカウントダウン処理を実行
  useEffect(() => {
    if (isOpen) {
      const id = window.setInterval(countdown, 1000);
      setIntervalID(id);
    }
  }, [countdown, isOpen]);

  useEffect(() => {
    if (timeLimit === 0) {
      clearInterval(intervalID);
      action();
    }
  }, [action, intervalID, timeLimit]);

  return (
    <>
      <Transition visible={isOpen} animation="fade up" duration={500}>
        <Modal open={isOpen} data-cy="timeup-modal">
          <Modal.Header data-cy="timeup-modal-header">制限時間となりました</Modal.Header>
          <Modal.Content data-cy="timeup-modal-content">
            <p style={{ padding: '20px' }}>{`${moment(timeLimit).format('s秒')}後に${modalMessage}`} </p>
          </Modal.Content>
        </Modal>
      </Transition>
    </>
  );
};
export default TimeUpModal;
